import React, { ReactElement } from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import { Button, Grid } from '@material-ui/core';
import CustomToolbar from 'components/molecules/CustomToolBarMuiDatatable/CustomToolbarMuiDatatable';
import { ICategoriesPromotion } from 'interfaces/imCategories.interface';

interface Props {
  IMCategoriesPromotion: ICategoriesPromotion[];
  isLoading: boolean;
  handleOnClickEditCategory: (wareHouseId: string) => void;
  handleOnClickDeleteCategory: (wareHouseId: string) => void;
  addCategoryPromoButton: () => void;
}
export default function IMCategoriesPromotionList({
  IMCategoriesPromotion,
  isLoading,
  handleOnClickEditCategory,
  handleOnClickDeleteCategory,
  addCategoryPromoButton
}: Props): ReactElement {
  const columnsPromotion: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'name',
      label: 'Categoría'
    },
    {
      name: 'isPromotion',
      label: 'Es promoción',
      options: {
        customBodyRender: (value) => {
          if (value) {
            return <div>Sí</div>;
          } else {
            return <div>No</div>;
          }
        }
      }
    },
    {
      name: 'percentage',
      label: 'Porcentaje',
      options: {
        customBodyRender: (value) => <div>{value}%</div>
      }
    },
    {
      name: '',
      label: 'Acciones',
      options: {
        filter: false,
        sort: false,
        download: false,
        print: false,
        empty: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <Grid container justify="flex-start">
              <Button
                variant="outlined"
                size="small"
                style={{ marginRight: 5 }}
                color="primary"
                onClick={() => {
                  handleOnClickEditCategory(tableMeta.rowData[0]);
                }}
              >
                Editar
              </Button>
              <Button
                variant="outlined"
                size="small"
                color="default"
                onClick={() => {
                  handleOnClickDeleteCategory(tableMeta.rowData[0]);
                }}
              >
                Eliminar
              </Button>
            </Grid>
          );
        }
      }
    }
  ];

  const optionsPromotion: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    viewColumns: false,
    searchOpen: true,
    customToolbar: () => {
      return <CustomToolbar tooltip="Agregar categoría" onClick={addCategoryPromoButton} />;
    }
  };

  return (
    <React.Fragment>
      <div>
        <MuiTable
          title="Listado de Categorías con Promoción"
          isLoading={isLoading}
          columns={columnsPromotion}
          data={IMCategoriesPromotion}
          options={optionsPromotion}
        />
      </div>
    </React.Fragment>
  );
}
